import { IApplicationContext } from '../../types';
import {
  TCianApiSiteV1GetUserDataByRequestResponse,
  fetchCianApiSiteV1GetUserDataByRequest,
} from '../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';
import { IFastFiltersUserSchema } from '../../repositories/monolith-python/entities/schemas/FastFiltersUserSchema';

export async function getUser(context: IApplicationContext): Promise<IFastFiltersUserSchema | null> {
  const {
    logger,
    httpApi,
    custom: { subdomain },
  } = context;

  try {
    const response: TCianApiSiteV1GetUserDataByRequestResponse = await fetchCianApiSiteV1GetUserDataByRequest({
      httpApi,
      config: {
        subdomain,
      },
    });

    return response.response.data.user ?? null;
  } catch (error) {
    logger.error(error, {
      domain: 'getUser',
      message: 'Не удалось получить пользователя',
    });

    return null;
  }
}
